import React from "react";
import { Link } from "react-router-dom";

export const POLICY_UPDATED = "October 19, 2026";

const policyLinks = [
  ["/policies", "Policy center"],
  ["/faqs", "Frequently asked questions"],
  ["/shipping", "Shipping & delivery"],
  ["/returns", "Returns & refunds"],
  ["/orders", "Order processing"],
  ["/cancellations", "Order changes & cancellations"],
  ["/payments", "Payments & pricing"],
  ["/preorders", "Pre-orders & backorders"],
  ["/subscriptions", "Subscription terms"],
  ["/promotions", "Promotions & discount codes"],
  ["/gift-cards", "Gift card terms"],
  ["/wholesale", "Wholesale & corporate orders"],
  ["/marketplaces", "Third-party sales channels"],
  ["/warranty", "Product care & warranty"],
  ["/product-safety", "Product safety & recalls"],
  ["/privacy", "Privacy policy"],
  ["/privacy-choices", "Your privacy choices"],
  ["/cookies", "Cookie policy"],
  ["/communications", "Email & SMS communications"],
  ["/reviews", "Reviews & user content"],
  ["/security", "Security & fraud prevention"],
  ["/terms", "Terms of service"],
  ["/intellectual-property", "Intellectual property"],
  ["/accessibility", "Accessibility"],
];

export default function PolicyNav({ current }) {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <nav className="policy-nav" aria-label="Policies and customer care">
      <p>Policies &amp; support</p>
      {policyLinks.map(([to, label]) => {
        const isCurrent = to === current;

        return (
          <Link
            className={isCurrent ? "is-active" : undefined}
            key={to}
            to={to}
            onClick={toTop}
            aria-current={isCurrent ? "page" : undefined}
          >
            {label} <span aria-hidden="true">→</span>
          </Link>
        );
      })}
    </nav>
  );
}
